/* Auto-generated by forest_models/scripts/generate_types.py — do not edit manually. */
/* Species data is synced from forest_models.species_mapping; model types are */
/* re-exported from ./api (generated by openapi-typescript from the Pydantic */
/* models via the FastAPI OpenAPI spec). Regenerate with `npm run gen:types`. */

import type { components } from './api';

export const SAVED_PLAN_BASELINE_BRANCH_ID = "baseline" as const;

export const TENDER_NEAR_TERM_FIRST_CUT_WINDOW_YEARS = 5 as const;

export const SPECIES_MAPPING: Record<string, {fi: string, sv: string, en: string, es: string}> = {
  '1': {
    fi: "Mänty",
    sv: "Tall",
    en: "Pine",
    es: "Pino"
  },
  '2': {
    fi: "Kuusi",
    sv: "Gran",
    en: "Spruce",
    es: "Abeto"
  },
  '3': {
    fi: "Rauduskoivu",
    sv: "Vårtbjörk",
    en: "Silver birch",
    es: "Abedul plateado"
  },
  '4': {
    fi: "Hieskoivu",
    sv: "Glasbjörk",
    en: "Downy birch",
    es: "Abedul velloso"
  },
  '5': {
    fi: "Haapa",
    sv: "Asp",
    en: "Asp",
    es: "Álamo temblón"
  },
  '6': {
    fi: "Harmaaleppä",
    sv: "Gråal",
    en: "Grey alder",
    es: "Aliso gris"
  },
  '7': {
    fi: "Tervaleppä",
    sv: "Klibbal",
    en: "Black alder",
    es: "Aliso negro"
  },
  '8': {
    fi: "Muu havupuu",
    sv: "Annat barrträdslag",
    en: "Other coniferous tree",
    es: "Otra conífera"
  },
  '9': {
    fi: "Muu lehtipuu",
    sv: "Annat lövträdslag",
    en: "Other deciduous tree",
    es: "Otra frondosa"
  },
  '10': {
    fi: "Douglaskuusi",
    sv: "Douglasgran",
    en: "Oregon pine",
    es: "Pino de Oregón"
  },
  '11': {
    fi: "Kataja",
    sv: "En",
    en: "Common juniper",
    es: "Enebro común"
  },
  '12': {
    fi: "Kontortamänty",
    sv: "Contortatall",
    en: "Contorta pine",
    es: "Pino contorta"
  },
  '13': {
    fi: "Kynäjalava",
    sv: "Vresalm",
    en: "European white elm",
    es: "Olmo blanco europeo"
  },
  '14': {
    fi: "Lehtikuusi",
    sv: "Lärkträd",
    en: "Larch",
    es: "Alerce"
  },
  '15': {
    fi: "Metsälehmus",
    sv: "Skogslind",
    en: "Small-leaved lime",
    es: "Tilo de hoja pequeña"
  },
  '16': {
    fi: "Mustakuusi",
    sv: "Svartgran",
    en: "Black spruce",
    es: "Abeto negro"
  },
  '17': {
    fi: "Paju",
    sv: "Vide",
    en: "Willow",
    es: "Sauce"
  },
  '18': {
    fi: "Pihlaja",
    sv: "Rönn",
    en: "Rowan",
    es: "Serbal"
  },
  '19': {
    fi: "Pihta",
    sv: "Pichtagran",
    en: "Fir",
    es: "Abeto"
  },
  '20': {
    fi: "Raita",
    sv: "Sälg",
    en: "Goat willow",
    es: "Sauce cabruno"
  },
  '21': {
    fi: "Saarni",
    sv: "Ask",
    en: "Ash",
    es: "Fresno"
  },
  '22': {
    fi: "Sembramänty",
    sv: "Cembratall",
    en: "Swiss pine",
    es: "Pino cembro"
  },
  '23': {
    fi: "Serbiankuusi",
    sv: "Omorikagran",
    en: "Serbian spruce",
    es: "Abeto serbio"
  },
  '24': {
    fi: "Tammi",
    sv: "Ek",
    en: "Oak",
    es: "Roble"
  },
  '25': {
    fi: "Tuomi",
    sv: "Hägg",
    en: "Bird cherry",
    es: "Cerezo de Padua"
  },
  '26': {
    fi: "Vaahtera",
    sv: "Lönn",
    en: "Maple",
    es: "Arce"
  },
  '27': {
    fi: "Visakoivu",
    sv: "Masurbjörk",
    en: "Curly birch",
    es: "Abedul rizado"
  },
  '28': {
    fi: "Vuorijalava",
    sv: "Skogsalm",
    en: "Scots elm",
    es: "Olmo escocés"
  },
  '29': {
    fi: "Lehtipuu",
    sv: "Lövträd",
    en: "Deciduous tree",
    es: "Árbol caducifolio"
  },
  '30': {
    fi: "Havupuu",
    sv: "Barrträd",
    en: "Coniferous tree",
    es: "Árbol conífero"
  },
  '103': {
    fi: "Koivu",
    sv: "Björk",
    en: "Mixed birch",
    es: "Abedul mixto"
  },
  '106': {
    fi: "Leppä",
    sv: "Al",
    en: "Alder",
    es: "Aliso"
  },
  '201': {
    fi: "Sekapuu",
    sv: "Blandträd",
    en: "Mixed wood",
    es: "Madera mixta"
  },
};

// Species code -> LUKE timber-price species family (Pine, Spruce, Birch,
// Alder, Aspen, Other conifers, Other hardwoods), synced from the
// luke_name column of forest_models.species_mapping.
export const SPECIES_LUKE_FAMILY: Record<string, string> = {
  '1': "Pine",
  '2': "Spruce",
  '3': "Birch",
  '4': "Birch",
  '5': "Aspen",
  '6': "Alder",
  '7': "Alder",
  '8': "Other conifers",
  '9': "Other hardwoods",
  '10': "Other conifers",
  '11': "Other conifers",
  '12': "Pine",
  '13': "Other hardwoods",
  '14': "Other conifers",
  '15': "Other hardwoods",
  '16': "Spruce",
  '17': "Other hardwoods",
  '18': "Other hardwoods",
  '19': "Other conifers",
  '20': "Other hardwoods",
  '21': "Other hardwoods",
  '22': "Pine",
  '23': "Spruce",
  '24': "Other hardwoods",
  '25': "Other hardwoods",
  '26': "Other hardwoods",
  '27': "Birch",
  '28': "Other hardwoods",
  '29': "Birch",
  '30': "Pine",
  '103': "Birch",
  '106': "Alder",
  '201': "Birch",
};

// MV1.9 fertility class -> site-type code, synced from the ONE table
// forest_models.mela_mapping.FERTILITY_CLASS_TO_SITE_TYPE.
export const FERTILITY_CLASS_TO_SITE_TYPE: Record<string, string> = {
  '1': "LEHTO",
  '2': "OMT",
  '3': "MT",
  '4': "VT",
  '5': "CT",
  '6': "CLT",
  '7': "ECT",
  '8': "EST",
};

// Plan operation tokens that remove stems an offer can price, synced from
// forest_models.harvest_removal_contract.HARVEST_OPERATION_TOKENS.
export const HARVEST_OPERATION_TOKENS: readonly string[] = ["CLEARFELL", "OVERSTORY_REMOVAL", "THINNING", "THINNING_FIRST"];

// Operation token -> owner-facing name per language, synced from the ONE
// owner forest_models.operation_labels.OPERATION_LABELS.
export type OperationLabelToken = "THINNING" | "THINNING_FIRST" | "CLEARFELL" | "PRE_FELL_PREP" | "SITE_PREP" | "REGENERATION" | "TENDING" | "PLANTING" | "SOWING" | "NATURAL_REGENERATION" | "NATURAL_NO_PREP" | "EARLY_TENDING" | "JUVENILE_THINNING" | "OVERSTORY_REMOVAL" | "DRAINAGE_MAINTENANCE" | "FERTILIZATION" | "PRUNING";
export const OPERATION_LABELS: Record<OperationLabelToken, {fi: string, sv: string, en: string, es: string}> = {
  "THINNING": {
    fi: "Harvennus",
    sv: "Gallring",
    en: "Thinning",
    es: "Aclareo",
  },
  "THINNING_FIRST": {
    fi: "Ensiharvennus",
    sv: "Första gallring",
    en: "First thinning",
    es: "Primer aclareo",
  },
  "CLEARFELL": {
    fi: "Avohakkuu",
    sv: "Kalavverkning",
    en: "Clearcutting",
    es: "Corta a hecho",
  },
  "PRE_FELL_PREP": {
    fi: "Ennakkoraivaus",
    sv: "Hyggesrensning före avverkning",
    en: "Pre-clearing",
    es: "Desbroce previo",
  },
  "SITE_PREP": {
    fi: "Maanmuokkaus",
    sv: "Markberedning",
    en: "Soil preparation",
    es: "Preparación del terreno",
  },
  "REGENERATION": {
    fi: "Uudistaminen",
    sv: "Förnyelse",
    en: "Regeneration",
    es: "Regeneración",
  },
  "TENDING": {
    fi: "Taimikonhoito",
    sv: "Plantbeståndsvård",
    en: "Pre-commercial thinning",
    es: "Cuidado de masas jóvenes",
  },
  "PLANTING": {
    fi: "Istutus",
    sv: "Plantering",
    en: "Planting",
    es: "Plantación",
  },
  "SOWING": {
    fi: "Kylvö",
    sv: "Sådd",
    en: "Seeding",
    es: "Siembra",
  },
  "NATURAL_REGENERATION": {
    fi: "Luontainen uudistaminen",
    sv: "Naturlig förnyelse",
    en: "Natural regeneration",
    es: "Regeneración natural",
  },
  "NATURAL_NO_PREP": {
    fi: "Luontainen uudistaminen ilman maanmuokkausta",
    sv: "Naturlig förnyelse utan markberedning",
    en: "Natural regeneration without soil preparation",
    es: "Regeneración natural sin preparación del terreno",
  },
  "EARLY_TENDING": {
    fi: "Taimikon varhaishoito",
    sv: "Slyröjning",
    en: "Early pre-commercial thinning",
    es: "Clareo temprano",
  },
  "JUVENILE_THINNING": {
    fi: "Taimikonharvennus",
    sv: "Plantskogsgallring",
    en: "Thinning of recently planted forest",
    es: "Clareo del repoblado",
  },
  "OVERSTORY_REMOVAL": {
    fi: "Ylispuiden poisto",
    sv: "Avverkning av frö- och skärmträd",
    en: "Removal of seed trees and shelterwood trees",
    es: "Corta de sobrepiso",
  },
  "DRAINAGE_MAINTENANCE": {
    fi: "Kunnostusojitus",
    sv: "Iståndsättningsdikning",
    en: "Ditch network maintenance",
    es: "Mantenimiento de la red de drenaje",
  },
  "FERTILIZATION": {
    fi: "Lannoitus",
    sv: "Gödsling",
    en: "Fertilisation",
    es: "Fertilización",
  },
  "PRUNING": {
    fi: "Pystykarsinta",
    sv: "Stamkvistning",
    en: "Pruning",
    es: "Poda",
  },
};

// Planner treatment category -> name per language, synced from
// forest_models.operation_labels.PLANNER_OPERATION_TYPE_LABELS.
export type PlannerOperationType = "thinning" | "seed-tree" | "clearcut" | "planting" | "tending";
export const PLANNER_OPERATION_TYPE_LABELS: Record<PlannerOperationType, {fi: string, sv: string, en: string, es: string}> = {
  "thinning": {
    fi: "Harvennus",
    sv: "Gallring",
    en: "Thinning",
    es: "Aclareo",
  },
  "seed-tree": {
    fi: "Siemenpuuhakkuu",
    sv: "Avverkning i fröträdsställning",
    en: "Seed tree felling",
    es: "Corta de árboles semilleros",
  },
  "clearcut": {
    fi: "Avohakkuu",
    sv: "Kalavverkning",
    en: "Clearcutting",
    es: "Corta a hecho",
  },
  "planting": {
    fi: "Istutus",
    sv: "Plantering",
    en: "Planting",
    es: "Plantación",
  },
  "tending": {
    fi: "Taimikonhoito",
    sv: "Plantbeståndsvård",
    en: "Pre-commercial thinning",
    es: "Cuidado de masas jóvenes",
  },
};

// LUKE timber species code -> name per language, synced from the ONE
// owner forest_models.implementation_scope.TIMBER_SPECIES_NAMES.
export type TimberSpeciesCode = "1" | "2" | "3";
export const TIMBER_SPECIES_NAMES: Record<TimberSpeciesCode, {fi: string, sv: string, en: string, es: string}> = {
  "1": {
    fi: "Mänty",
    sv: "Tall",
    en: "Pine",
    es: "Pino",
  },
  "2": {
    fi: "Kuusi",
    sv: "Gran",
    en: "Spruce",
    es: "Abeto",
  },
  "3": {
    fi: "Koivu",
    sv: "Björk",
    en: "Birch",
    es: "Abedul",
  },
};

// Species utility functions
export type SpeciesLanguage = 'fi' | 'sv' | 'en' | 'es';

/**
 * A value that is not a forest_models species code. The server serves codes on
 * every species field, so reaching this means a contract bug at the caller; it
 * is refused by name rather than rendered under an invented label.
 */
export class UnknownSpeciesCodeError extends Error {
  readonly speciesCode: string;

  constructor(speciesCode: string) {
    super(`Unknown species code '${speciesCode}': it is not in forest_models.species_mapping.`);
    this.name = 'UnknownSpeciesCodeError';
    this.speciesCode = speciesCode;
  }
}

export function isSpeciesCode(value: string | number): boolean {
  return Object.prototype.hasOwnProperty.call(SPECIES_MAPPING, String(value).trim());
}

/**
 * The species code a map stand serves under ``species_code``, or ``null`` when
 * it serves none. A value outside forest_models.species_mapping is not a
 * species, so the stand draws neutral rather than under an invented species.
 */
export function servedStandSpeciesCode(props: Readonly<Record<string, unknown>>): number | null {
  const value = props.species_code;
  const text = typeof value === 'number' || typeof value === 'string' ? String(value).trim() : '';
  return /^\d+$/.test(text) && isSpeciesCode(text) ? Number(text) : null;
}

export function getSpeciesName(code: string | number, language: SpeciesLanguage): string {
  const key = String(code).trim();
  if (!isSpeciesCode(key)) {
    throw new UnknownSpeciesCodeError(key);
  }
  return SPECIES_MAPPING[key][language];
}

/**
 * The name of a timber species an aggregate serves ("1" pine, "2" spruce,
 * "3" birch, under which every deciduous species is sold), as the buyer's PDF
 * prints it. Never the forest species name of the same code.
 */
export function timberSpeciesName(code: TimberSpeciesCode, language: SpeciesLanguage): string {
  return TIMBER_SPECIES_NAMES[code][language];
}

export function isOperationLabelToken(value: string): value is OperationLabelToken {
  return Object.prototype.hasOwnProperty.call(OPERATION_LABELS, value);
}

/**
 * The owner-facing name of an operation token, or ``null`` for a value that is
 * not an operation token: the caller shows nothing rather than an invented name.
 */
export function operationLabel(token: string, language: SpeciesLanguage): string | null {
  return isOperationLabelToken(token) ? OPERATION_LABELS[token][language] : null;
}

export function isPlannerOperationType(value: string): value is PlannerOperationType {
  return Object.prototype.hasOwnProperty.call(PLANNER_OPERATION_TYPE_LABELS, value);
}

/**
 * The name of one planned operation: its served operation token's name when the
 * token is a named operation, otherwise its planner treatment category's name,
 * so a row reads exactly what the plan PDF and workbook print for that token.
 * A row carrying neither a named token nor a planner category shows nothing.
 */
export function plannedOperationLabel(
  operation: { type: string; operationToken?: string | null },
  language: SpeciesLanguage,
): string {
  const token = operation.operationToken;
  const tokenName = token ? operationLabel(token, language) : null;
  if (tokenName !== null) return tokenName;
  return isPlannerOperationType(operation.type)
    ? PLANNER_OPERATION_TYPE_LABELS[operation.type][language]
    : '';
}

export function plannerOperationTypeLabels(
  language: SpeciesLanguage,
): Record<PlannerOperationType, string> {
  return {
    thinning: PLANNER_OPERATION_TYPE_LABELS.thinning[language],
    'seed-tree': PLANNER_OPERATION_TYPE_LABELS['seed-tree'][language],
    clearcut: PLANNER_OPERATION_TYPE_LABELS.clearcut[language],
    planting: PLANNER_OPERATION_TYPE_LABELS.planting[language],
    tending: PLANNER_OPERATION_TYPE_LABELS.tending[language],
  };
}

// Canonical model types — re-exported from the openapi-typescript output.
// These keep the Pydantic models as the single source of truth.
export type CoreStandData = components['schemas']['CoreStandData'];
export type CoreTreeStratum = components['schemas']['CoreTreeStratum'];
export type SiteCharacteristics = components['schemas']['SiteCharacteristics'];
export type DetailedForestStand = components['schemas']['DetailedForestStand'];
export type PropertyDetailedAnalysis = components['schemas']['PropertyDetailedAnalysis'];
export type TreeStratum = components['schemas']['TreeStratum'];
export type SpeciesVolumeBreakdown = components['schemas']['SpeciesVolumeBreakdown'];
export type SimulationRequestParameters = components['schemas']['SimulationRequestParameters'];
export type SimulationInput = components['schemas']['SimulationInput'];
export type SimulationResponse = components['schemas']['SimulationResponse'];
export type SimulationResponseExtended = components['schemas']['SimulationResponseExtended'];
export type BranchRootStrata = components['schemas']['BranchRootStrata'];
export type BranchRootStratum = components['schemas']['BranchRootStratum'];
export type SimulationTimeStep = components['schemas']['SimulationTimeStep'];
export type SimulationTimeStepExtended = components['schemas']['SimulationTimeStepExtended'];
export type TapioScheduleEcho = components['schemas']['TapioScheduleEcho'];
export type AssortmentValueEntry = components['schemas']['AssortmentValueEntry'];
export type StandValueAtTimestep = components['schemas']['StandValueAtTimestep'];
export type StandValueGrowthSeries = components['schemas']['StandValueGrowthSeries'];
export type YearlyValueGrowthEntry = components['schemas']['YearlyValueGrowthEntry'];
export type SellWaitVerdict = components['schemas']['SellWaitVerdict'];
export type MeasurementAtlasSnapshot = components['schemas']['MeasurementAtlasSnapshot'];
export type MeasurementDashboardSnapshot = components['schemas']['MeasurementDashboardSnapshot'];
export type MeasurementPropertySnapshot = components['schemas']['MeasurementPropertySnapshot'];
export type MeasurementStandContextSnapshot = components['schemas']['MeasurementStandContextSnapshot'];
export type MeasurementCampaignSnapshot = components['schemas']['MeasurementCampaignSnapshot'];
export type ConcreteSavedPlanStandBranchPayload = components['schemas']['ConcreteSavedPlanStandBranchPayload'];
export type ConcreteSavedPlanStandBranchesPayload = components['schemas']['ConcreteSavedPlanStandBranchesPayload'];
export type SavedPlanStandBranchPayload = components['schemas']['SavedPlanStandBranchPayload'];
export type SavedPlanStandBranchesPayload = components['schemas']['SavedPlanStandBranchesPayload'];
export type TapioTrajectoryGatewayRequest = components['schemas']['TapioTrajectoryGatewayRequest'];
export type TapioTrajectoryResponse = components['schemas']['TapioTrajectoryResponse'];
export type TapioChartPosition = components['schemas']['TapioChartPosition'];
export type TapioCorridorBreakpoint = components['schemas']['TapioCorridorBreakpoint'];
export type TapioRefusalParams = components['schemas']['TapioRefusalParams'];
export type TapioPositionRefusal = components['schemas']['TapioPositionRefusal'];
export type TapioRateCorridor = components['schemas']['TapioRateCorridor'];
export type TapioStatutoryFloor = components['schemas']['TapioStatutoryFloor'];
export type TapioTrajectoryPoint = components['schemas']['TapioTrajectoryPoint'];
export type TapioTrajectoryGap = components['schemas']['TapioTrajectoryGap'];
export type TapioBranchTrajectory = components['schemas']['TapioBranchTrajectory'];
export type ImplementationScopeAggregateRequest = components['schemas']['ImplementationScopeAggregateRequest'];
export type ImplementationScopeAggregate = components['schemas']['ImplementationScopeAggregate'];
export type ImplementationScopeCandidatesRequest = components['schemas']['ImplementationScopeCandidatesRequest'];
export type ImplementationScopeCandidates = components['schemas']['ImplementationScopeCandidates'];
export type ImplementationScopeRecomputeRequest = components['schemas']['ImplementationScopeRecomputeRequest'];
export type ImplementationScopeRecompute = components['schemas']['ImplementationScopeRecompute'];
export type OfferExtraction = components['schemas']['OfferExtraction'];
export type OfferDocumentReadiness = components['schemas']['OfferDocumentReadiness'];
export type HarvestRemovalRequest = components['schemas']['HarvestRemovalRequest'];
export type HarvestRemovalBasis = components['schemas']['HarvestRemovalBasis'];
export type OfferRemovalBasisResponse = components['schemas']['OfferRemovalBasisResponse'];
export type ConfirmedOffersRequest = components['schemas']['ConfirmedOffersRequest'];
export type ConfirmedOffers = components['schemas']['ConfirmedOffers'];
export type OfferDecodeRequest = components['schemas']['OfferDecodeRequest'];
export type OfferDecodeRecord = components['schemas']['OfferDecodeRecord'];
export type OfferDecodeHistory = components['schemas']['OfferDecodeHistory'];
export type OfferDecodeEntitlement = components['schemas']['OfferDecodeEntitlement'];
export type OfferReaderConfiguration = components['schemas']['OfferReaderConfiguration'];
export type BuyerSpecPrefill = components['schemas']['BuyerSpecPrefill'];
export type PlanRecomputeRefusalCode = components['schemas']['PlanRecomputeRefusalCode'];
export type PlanRecomputeFailureCode = components['schemas']['PlanRecomputeFailureCode'];
export type PlanRecomputeState = components['schemas']['PlanRecomputeState'];
export type TenderLeftOutReason = components['schemas']['TenderLeftOutReason'];
